import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import {
  InputCustomPropType,
  InputSizeIconPropType,
  InputSizePropType,
  TextAreaProps,
} from "../../interface/input";
import { styInput, textareaSty } from "./styles-input";
import { makeStyles } from "@mui/styles";



const useStyles = makeStyles((theme) => ({
  customInput: {
    "& .MuiFormControl-root": {
      backgroundColor: "#fff", // Replace with your desired color
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      borderRadius: "8px", // Adjust this value as needed
      "& fieldset": {
        border: "none",
      },
    },
    "& .MuiInputBase-input": {
      fontFamily: '"Lexend", sans-serif', // Replace with your desired font
    },

    iconButton: {
      padding: "4px", // Adjust padding as needed
    },
    icon: {
      fontSize: "18px", // Adjust size as needed
      color: "#757575", // Adjust color as needed
    },
  },
}));

const InputCustom = ({
  placeholder,
  value,
  styles,
  type,
  onchange,
}: InputCustomPropType) => {
  return (
    <TextField
      sx={{ ...styles }}
      placeholder={placeholder ?? "Enter your email address or phone number"}
      type={type}
      value={value}
      onChange={onchange}
      size={"small"}
      InputProps={{
        inputProps: {
          style: styInput,
        },
      }}
    ></TextField>
  );
};

const InputCustomSize = ({
  placeholder,
  value,
  styles,
  type,
  onchange,
  size,
}: InputSizePropType) => {
  return (
    <TextField
      sx={{ ...styles }}
      placeholder={placeholder ?? "Enter your email address or phone number"}
      type={type}
      value={value}
      onChange={onchange}
      size={size}
      InputProps={{
        inputProps: {
          style: styInput,
        },
      }}
    ></TextField>
  );
};

 const InputCustomIcon = ({
  placeholder,
  value,
  styles,
  type,
  onchange,
  size,
  icon
}: InputSizeIconPropType) => {
  const classes = useStyles();

  return (
    <TextField
      placeholder={placeholder}
      type={type}
      className={classes.customInput}
      value={value}
      onChange={onchange}
      size={size}
      sx={{
        '& .MuiInputBase-root': {
          backgroundColor: '#f5f7f9',  // Change input background
          borderRadius: '8px',         // Rounded corners
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'none',      // Outline color
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#none',      // Outline color on hover
        },
        '& .MuiInputLabel-root': {
          color: '#4CAF50',            // Label color
        },
      }}
      InputProps={{
        endAdornment: <InputAdornment position="end">{icon}</InputAdornment>,
        inputProps: {
          style: styInput,
        },
      }}
    />
  );
};

const TextArea = ({ placeholder, value, onchange }: TextAreaProps) => {
  return (
    <textarea
      className="text-area"
      style={textareaSty}
      onChange={onchange}
      rows={4}
      value={value}
      placeholder={placeholder}
    />
  );
};

export { InputCustom, InputCustomSize, TextArea, InputCustomIcon };
